// v7 — Annotation hotspot shape. Coordinates are image-relative (0..1)
// so an annotation sticks to the iris regardless of the rendered image size.
//
// Serialised as a JSON column on the catalogue row.

export interface Annotation {
  id: string;
  /** 0..1 horizontal position relative to the image width. */
  x: number;
  /** 0..1 vertical position relative to the image height. */
  y: number;
  /** 0..1 hotspot radius (defaults to ~3% of the image width when omitted). */
  radius?: number;
  /** Free-form note shown when the hotspot is opened / read-only. */
  text: string;
  /** ISO-8601 created_at — populated by the client when the hotspot is added. */
  created_at: string;
}

export function makeAnnotationId(): string {
  // Cheap, stable-ish id. We don't need cryptographic uniqueness — the
  // client is the only writer and React keys are the only consumer.
  const random = Math.random().toString(36).slice(2, 10);
  return `ann-${Date.now().toString(36)}-${random}`;
}
